import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconPenUnderline: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M15.833 16.6665H4.16634C3.94533 16.6665 3.73337 16.7543 3.57709 16.9106C3.42081 17.0669 3.33301 17.2788 3.33301 17.4998C3.33301 17.7209 3.42081 17.9328 3.57709 18.0891C3.73337 18.2454 3.94533 18.3332 4.16634 18.3332H15.833C16.054 18.3332 16.266 18.2454 16.4223 18.0891C16.5785 17.9328 16.6663 17.7209 16.6663 17.4998C16.6663 17.2788 16.5785 17.0669 16.4223 16.9106C16.266 16.7543 16.054 16.6665 15.833 16.6665Z"
        fill={fill}
      />
      <path
        d="M4.16691 15H4.24191L7.71691 14.6834C8.09758 14.6455 8.45361 14.4777 8.72525 14.2084L16.2252 6.70838C16.5163 6.40085 16.6737 5.99047 16.6627 5.56716C16.6518 5.14385 16.4735 4.74213 16.1669 4.45004L13.8836 2.16671C13.5856 1.88679 13.1951 1.72618 12.7864 1.71542C12.3776 1.70467 11.9792 1.84452 11.6669 2.10838L4.16691 9.60838C3.89755 9.88001 3.72983 10.236 3.69191 10.6167L3.33358 14.0917C3.32235 14.2138 3.33819 14.3368 3.37996 14.452C3.42174 14.5673 3.48842 14.6719 3.57525 14.7584C3.65311 14.8356 3.74546 14.8967 3.84699 14.9382C3.94852 14.9797 4.05724 15.0007 4.16691 15ZM12.7252 3.33338L15.0002 5.60838L13.3336 7.23338L11.1002 5.00004L12.7252 3.33338ZM5.30858 10.7584L10.0002 6.10004L12.2502 8.35004L7.58358 13.0167L5.08358 13.25L5.30858 10.7584Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconPenUnderline;
